import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import { useHistory } from "react-router-dom";

const BatchUpdateLogs = () => {
  const { jobId } = useParams();

  const apiToken = useContext(TokenContext);

  const [logs, setLogs] = useState([]);

  const history = useHistory();

  const [loading, setLoading] = useState(true);

  const [filteredLogs, setFilteredLogs] = useState([]);

  const [filters, setFilters] = useState({
    codiceFiscale: "",
    messaggio: "",
    stato: "",
  });

  const STATUS = {
    CREATED: 0,
    RUNNING: 1,
    SUCCESS: 2,
    ERROR: 3,
    SKIPPED: 4,
    REFUSED: 5,
  };

  useEffect(() => {
    loadLogs();
  }, [jobId]);

  useEffect(() => {
    applyFilters();
  }, [filters, logs]);

  const applyFilters = () => {
    let result = [...logs];

    if (filters.codiceFiscale) {
      result = result.filter((x) =>
        x.codiceFiscale
          ?.toLowerCase()
          .includes(filters.codiceFiscale.toLowerCase()),
      );
    }

    if (filters.messaggio) {
      result = result.filter((x) =>
        x.messaggio?.toLowerCase().includes(filters.messaggio.toLowerCase()),
      );
    }

    if (filters.stato !== "") {
      result = result.filter((x) => x.stato === Number(filters.stato));
    }

    setFilteredLogs(result);
  };

  const loadLogs = async () => {
    try {
      setLoading(true);

      const response = await Repo.getAggiornamentoLogs(apiToken, jobId);

      setLogs(response.data);
      setFilteredLogs(response.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const retry = async () => {
    try {
      setLoading(true);

      await Repo.PostRetryAggiornamento(apiToken, jobId);

      await loadLogs(); // <-- ricarica i log aggiornati
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getBadge = (status) => {
    switch (status) {
      case STATUS.CREATED:
        return <span className="badge badge-secondary">Creato</span>;

      case STATUS.RUNNING:
        return <span className="badge badge-warning">In esecuzione</span>;

      case STATUS.SUCCESS:
        return <span className="badge badge-success">Successo</span>;

      case STATUS.ERROR:
        return <span className="badge badge-danger">Errore</span>;

      case STATUS.REFUSED:
        return <span className="badge badge-info">Rifiutato</span>;

      case STATUS.SKIPPED:
        return <span className="badge badge-light">Saltato</span>;

      default:
        return <span className="badge badge-light">Sconosciuto</span>;
    }
  };

  const formatDate = (value) => {
    if (!value) return "-";

    return new Date(value).toLocaleString("it-IT");
  };

  if (loading) return <div className="container mt-4">Caricamento logs...</div>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Logs aggiornamento</h4>

        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => retry()}
        >
          Riprova
        </button>

        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => history.goBack()}
        >
          Indietro
        </button>
      </div>

      <div className="row mb-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Codice fiscale"
            value={filters.codiceFiscale}
            onChange={(e) =>
              setFilters({
                ...filters,
                codiceFiscale: e.target.value,
              })
            }
          />
        </div>

        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Messaggio"
            value={filters.messaggio}
            onChange={(e) =>
              setFilters({
                ...filters,
                messaggio: e.target.value,
              })
            }
          />
        </div>

        <div className="col-md-4">
          <select
            className="form-control"
            value={filters.stato}
            onChange={(e) =>
              setFilters({
                ...filters,
                stato: e.target.value,
              })
            }
          >
            <option value="">Tutti gli stati</option>
            <option value="0">Creato</option>
            <option value="1">In esecuzione</option>
            <option value="2">Successo</option>
            <option value="3">Errore</option>
              <option value="4">Saltato</option>
                <option value="5">Rifiutato</option>
          </select>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover table-bordered">
          <thead>
            <tr>
              <th>Codice fiscale</th>

              <th>Stato</th>

              <th>Messaggio</th>
            </tr>
          </thead>

          <tbody>
            {filteredLogs.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center">
                  Nessun log trovato
                </td>
              </tr>
            )}

            {filteredLogs.map((log) => (
              <tr key={log.id}>
                <td>
                  <button
                    className="btn btn-link p-0"
                    style={{ textDecoration: "underline" }}
                    onClick={() =>
                      history.push(
                        `/lista_utenti/dati_utente?citizen=${log.userId}`,
                      )
                    }
                  >
                    {log.codiceFiscale}
                  </button>
                </td>
                <td>{getBadge(log.stato)}</td>
                <td>{log.messaggio || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BatchUpdateLogs;
